<template>
  <div>
    <el-form :model="value" ref="formRef" :rules="formRules" label-width="95px">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="车场名称:" prop="spaceId">
            <el-select v-model="value.spaceId" style="width: 100%" placeholder="请选择" disabled>
              <el-option
                v-for="item in spaceList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车辆身份" prop="carManageType">
            <el-select v-model="value.carManageType" style="width: 100%" placeholder="请选择车辆身份" disabled >
              <el-option
                v-for="item in carManageTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车牌号:" prop="plateNumber">
            <el-input v-model="value.plateNumber" placeholder="请输入车牌号" disabled ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="主/副车" prop="isMainCar">
            <el-select v-model="value.isMainCar" style="width: 100%" placeholder="请选择主/副车" disabled >
              <el-option
                v-for="item in carCategoryList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车辆大小:" prop="bigOrSmallCar">
            <el-select
              v-model="value.bigOrSmallCar"
              style="width: 100%"
              placeholder="请选择车辆大小"
              @change="bigOrSmallCarChange"
              :disabled="value.isMainCar == 0"
            >
              <el-option
                v-for="item in bigOrSmallCarList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户姓名:" prop="personName">
            <el-input
              clearable
              v-model="value.personName"
              placeholder="请输入客户姓名"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户手机:" prop="personPhone">
            <el-input
              clearable
              v-model="value.personPhone"
              placeholder="请输入客户手机"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="楼栋/单元"
            prop="buildingId"
            :rules="[{ required: false, message: '请选择楼栋/单元', trigger: 'blur' }]"
          >
            <el-select @change="buildingIdChange" v-model="value.buildingId" style="width: 100%">
              <el-option
                style="padding-left: 10px"
                v-for="item in buildingList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="房间名称"
            prop="roomId"
            :rules="[{ required: false, message: '请选择房间名称', trigger: 'blur' }]"
          >
            <el-select @change="roomIdChange" v-model="value.roomId" style="width: 100%">
              <el-option
                style="padding-left: 10px"
                v-for="item in roomList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="value.carManageType==1">
          <el-form-item label="收费套餐:" prop="feeRuleId">
            <el-select
              v-model="value.feeRuleId"
              style="width: 100%"
              placeholder="请选择收费套餐"
              :disabled="value.isMainCar == 0"
              @change="ruleIdChange"
            >
              <el-option
                v-for="item in ruleList"
                :key="item.id"
                :label="item.setmealName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="租赁起期:" prop="effectTime">
            <el-date-picker
              v-model="value.effectTime"
              style="width: 100%"
              value-format="yyyy-MM-dd 00:00:00"
              align="right"
              type="date"
              placeholder="选择租赁起期"
              :disabled="value.isMainCar == 0 || value.carManageType == 2"
              @change="effectTimeChange"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="value.carManageType == 1">
          <el-form-item label="租赁时长" prop="cycleNum">
            <el-select
              :disabled="value.carManageType == 1 && value.isMainCar == 0"
              v-model="value.cycleNum"
              style="width: 100%"
              placeholder="请选择租赁时长"
              @change="cycleNumChange"
            >
              <el-option
                v-for="item in cycleNumList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="租赁止期:" prop="expiredTime">
            <el-date-picker
              v-model="value.expiredTime"
              style="width: 100%"
              value-format="yyyy-MM-dd 23:59:59"
              align="right"
              type="date"
              placeholder="选择租赁止期"
              disabled
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="value.carManageType==1">
          <el-form-item label="优惠规则:" prop="discountRuleId">
            <el-select
              v-model="value.discountRuleId"
              style="width: 100%"
              placeholder="请选择优惠规则"
              :disabled="value.isMainCar == 0"
              clearable
            >
              <el-option
                v-for="item in discountRuleList"
                :key="item.id"
                :label="item.discountName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8"
                v-if="(value.carManageType==2 || value.carManageType==1)&&value.isMainCar==1">
          <el-form-item label="车位编号">
            <el-input v-model="value.parkingSpaceNames">
              <el-button @click="selectCarCode" slot="append" type="primary">选择</el-button>
              <el-button @click="clearCarCode" slot="prepend" type="primary">清空</el-button>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8" v-if="value.carManageType==1&&value.isMainCar==0">
          <el-form-item label="关联主车">
            <el-input v-model="value.mainPlateNumber">
              <el-button @click="selectCarOwner" slot="append" type="primary">选择</el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="value.carManageType == 1 && value.isMainCar == 1">
          <el-form-item label="应收金额" prop="shouldAmount">
            <el-input
              clearable
              v-model="value.shouldAmount"
              placeholder=""
              disabled
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="value.carManageType == 1 && value.isMainCar == 1">
          <el-form-item label="优惠金额" prop="discountAmount">
            <el-input
              v-model="value.discountAmount"
              disabled
              placeholder=""
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="value.carManageType == 1 && value.isMainCar == 1">
          <el-form-item label="实收金额" prop="payAmount">
            <el-input
              disabled
              v-model="value.payAmount"
              placeholder=""
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="授权区域:" prop="regions">
            <avue-input-tree
              :disabled="value.isMainCar == 0"
              style="width: 100%"
              :props="treeRegionProps"
              v-model="value.regions"
              placeholder="请选择区域"
              type="tree"
              multiple
              checkStrictly
              :dic="regionList"
            ></avue-input-tree>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注:" prop="description">
            <el-input
              clearable
              v-model="value.description"
              type="textarea"
              :rows="4"
              placeholder="请输入备注"
              show-word-limit
              maxlength="200"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div style="float: right">
            <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="approveClick"
              size="small"
            >审核
            </el-button>
            <el-button icon="el-icon-circle-close" @click="cancelRecord" size="small">
              取消
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>


    <hr-dialog
      width='80%'
      :visible.sync="showCarCodeFlag"
      :title="'车辆编码'"
      :handleClose='handleCloseCarCodeFlag'
    >
      <template slot="body">
        <div>
          <parkvihicleCarCode
            v-if="showCarCodeFlag"
            :spaceId="value.spaceId"
            :carManageType="value.carManageType"
            :carId="value.id"
            @getCarCode="getCarCode"
          >
          </parkvihicleCarCode>
        </div>
      </template>
      <template slot="footer">
        <div class="btnArea" style="text-align:right;margin-right:24px">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="selectConfirm"
            style="margin-right: 20px"
          >确定
          </el-button>
          <el-button @click="closeCarCodeRecord" size="small" icon="el-icon-circle-close">取消</el-button>

        </div>
      </template>
    </hr-dialog>


    <hr-dialog
      width='80%'
      :visible.sync="showCarOwnerFlag"
      :title="'关联车主'"
      :handleClose='handleCloseCarOwnerFlag'
    >
      <template slot="body">
        <div>
          <parkvihicleCarOwner
            v-if="showCarOwnerFlag"
            :spaceId="value.spaceId"
            :carManageType="value.carManageType"
            :carId="value.id"
            @getCarOwner="getCarOwner"
          >
          </parkvihicleCarOwner>
        </div>
      </template>
      <template slot="footer">
        <div class="btnArea" style="text-align:right;margin-right:24px">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="selectCarOwnerConfirm"
            style="margin-right: 20px"
          >确定
          </el-button>
          <el-button @click="closeCarOwnerRecord" size="small" icon="el-icon-circle-close">取消</el-button>

        </div>
      </template>
    </hr-dialog>
  </div>
</template>
<script>
import {
  approve,
  getBuildingList,
  getRoomList,
  getCarRuleList,
  getCarRuleDiscountList,
  getManageDetail, calculateMonthCarFeeInFo, getCarRuleDiscountListNew
} from './parkvehicle';
import {nodeTreeByParentId} from '@/api/v4ward/carv2/carmonth';
import {getSpaceList, isCarMonth} from '@/api/v4ward/carv2/carmonthquickRegistration';
import {getDictionary} from '@/api/common.js';
import parkvihicleCarCode from '@/views/v4ward/park/vehiclev3/parkvehicle-carcode';
import parkvihicleCarOwner from '@/views/v4ward/park/vehiclev3/parkvehicle-carowner';

export default {
  components: {
    parkvihicleCarCode, parkvihicleCarOwner
  },
  props: ['value'],
  data() {
    return {
      buildingList: [],
      roomList: [],
      showCarOwnerFlag: false,
      showCarCodeFlag: false,
      regionList: [],
      treeRegionProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
      carManageTypeList: [],
      bigOrSmallCarList: [], //车辆类型
      carCategoryList: [], //车辆类别
      ruleList: [], //收费套餐
      discountRuleList: [], //优惠规则
      statusList: [], //月卡车状态
      spaceList: [], //车场
      //收费周期
      cycleNumList:[],
      formRules: {
        spaceId: [{required: true, message: '车场名称不能为空', trigger: 'blur'}],
        plateNumber: [{required: true, message: '车牌号不能为空', trigger: 'blur'}],
        regions: [{required: true, message: '区域不能为空', trigger: 'blur'}],
        isMainCar: [{required: true, message: '车辆类别不能为空', trigger: 'blur'}],
        bigOrSmallCar: [{required: true, message: '车辆类型不能为空', trigger: 'blur'}],
        feeRuleId: [{required: true, message: '收费套餐不能为空', trigger: 'blur'}],
        effectTime: [{required: true, message: '租赁起期不能为空', trigger: 'blur'}],
        expiredTime: [{required: true, message: '租赁止期不能为空', trigger: 'blur'}],
        personName: [{required: true, message: '客户姓名不能为空', trigger: 'blur'}],
        status: [{required: true, message: '月卡车状态不能为空', trigger: 'blur'}],

      },
    };
  },
  created() {
    this.value.bigOrSmallCar += '';
    this.value.isMainCar += '';
    this.value.feeRuleId += '';
    this.value.carStatus += '';
    this.initData();
  },
  methods: {
    //初始化收费周期
    getCycleNumList() {
      getDictionary('park_fee_cycle').then((res) => {
        this.cycleNumList = res.data;
      });
    },
    effectTimeChange() {
      this.computeMoney();
    },
    cycleNumChange() {
      this.value.discountRuleId = '';
      if (this.value.cycleNum && this.value.feeRuleId) {
        this.discountRuleDisabled = false;
        this.getDiscountList();
      }
      this.computeMoney();
    },
    ruleIdChange() {
      this.value.discountRuleId = '';
      this.value = this._.cloneDeep(this.value);
      if (this.value.cycleNum && this.value.feeRuleId) {
        this.discountRuleDisabled = false;
        this.getDiscountList();
      }
      this.computeMoney();
    },
    computeMoney() {
      if (
        this.value.cycleNum + '' !== 'undefined' &&
        this.value.feeRuleId + '' !== 'undefined' &&
        this.value.effectTime + '' !== 'undefined'
      ) {
        calculateMonthCarFeeInFo({
          feeRuleId: this.value.feeRuleId,
          spaceId: this.value.spaceId,
          cycleNum: this.value.cycleNum,
          discountRuleId: this.value.discountRuleId,
          effectTime: this.dayjs(this.value.effectTime).format('YYYY-MM-DD HH:mm:ss'),
        }).then((res) => {
          this.value.shouldAmount = res.data.shouldAmount;
          this.value.discountAmount = res.data.discountAmount;
          this.value.payAmount = res.data.payAmount;
          if (this.value.cycleNum && this.value.effectTime) {
            this.value.expiredTime = res.data.feeEndTime;
          }
          this.value = this._.cloneDeep(this.value);
        });
      }
    },
    roomIdChange(val) {
      this.roomList.forEach(ele => {
        if (ele.value == val) {
          this.value.roomName = ele.label
        }
      })
    },
    buildingIdChange(val,flag) {
      let this_ = this;
      if(!flag){
        this.value.roomId = '';
        this.value = this._.cloneDeep(this_.value);
      }
      getRoomList({buildingId: val}).then(res => {
        this.roomList = res.data;
      });
    },
    getCarOwner(val) {
      this.value.mainCarId = val[0];
      this.value.mainPlateNumber = val[1];
      if (!this.value.mainCarId) {
        return;
      }
      if (this.value.mainCarId && this.value.mainCarId.split(',').length > 1) {
        this.value.mainCarId = '';
        this.value.mainPlateNumber = '';
        this.$message.warning('请选择一条数据');
        return;
      }
      this.value = this._.cloneDeep(this.value);
      getManageDetail({ id: val[0] }).then((res) => {
        this.value.feeRuleId = res.data.feeRuleId;
        this.value.cycleNum = res.data.cycleNum;
        this.value.discountRuleId = res.data.discountRuleId;
        this.value.shouldAmount = res.data.shouldAmount;
        this.value.payAmount = res.data.payAmount;
        this.value.discountAmount = res.data.discountAmount;
        this.value.personName = res.data.personName;
        this.value.personPhone = res.data.personPhone;
        this.value.roomId = res.data.roomId;
        this.value.roomName = res.data.roomName;
        this.value.buildingId = res.data.buildingId;
        this.value.regions = res.data.regionIds.split(',');
        if (this.value.carManageType == 1) {
          this.value.effectTime = res.data.effectTime;
          this.value.expiredTime = res.data.expiredTime;
          getCarRuleList({
            spaceId: this.value.spaceId,
            packageType: this.value.carManageType,
            bigOrSmallCar: this.value.bigOrSmallCar,
          }).then((res) => {
            this.ruleList = res.data;
          });

          getCarRuleDiscountListNew({
            spaceId: this.value.spaceId,
            payPeriods: this.value.cycleNum,
            carFeeRuleId: this.value.feeRuleId,
          }).then((res) => {
            this.discountRuleList = res.data;
          });
        }
        console.log("getManageDetail=============>", res.data);
      });
    },
    selectCarOwner() {
      this.showCarOwnerFlag = true;
    },
    selectCarOwnerConfirm() {
      this.showCarOwnerFlag = false;
    },
    closeCarOwnerRecord() {
      this.showCarOwnerFlag = false;
    },
    handleCloseCarOwnerFlag() {
      this.closeCarOwnerRecord();
    },

    getCarCode(val) {
      this.value.parkingSpaceIds = val[0];
      this.value.parkingSpaceNames = val[1];
    },
    selectConfirm() {

      this.showCarCodeFlag = false;
    },
    closeCarCodeRecord() {
      this.showCarCodeFlag = false;
    },
    handleCloseCarCodeFlag() {
      this.closeCarCodeRecord();
    },
    selectCarCode() {
      this.showCarCodeFlag = true;
    },
    clearCarCode() {
      this.value.parkingSpaceIds = '';
      this.value.parkingSpaceNames = '';
      this.value.parkingSpaceIds_ = '';
      this.value.parkingSpaceNames_ = '';
    },
    bigOrSmallCarChange() {
      this.value.feeRuleId = '';
      this.value.discountRuleId = '';
      if (this.value.bigOrSmallCar && this.value.isMainCar) {
        this.getCarRuleListHandler();
      }
    },
    initData() {
      this.getSpaceList();
      this.getRegion(this.value.spaceId);
      this.getCarCategory();
      this.getBigOrSmallCar();
      this.getDiscountList();
      this.getCarMonthStatus();
      this.getCycleNumList();
      this.getCarManageTypeList();
      this.getCarRuleListHandler();
      this.buildingIdChange(this.value.roomId,1);

      this.getBuildingListHandler(this.value.spaceId);
      this.value.regions = this.value.regionIds.split(',');
    },
    getBuildingListHandler() {
      getBuildingList({spaceId: this.value.spaceId}).then((res) => {
        this.buildingList = res.data;
      })
    },
    getSpaceList() {
      getSpaceList().then((res) => {
        this.spaceList = res.data;
      });
    },
    //获取区域
    getRegion(id) {
      nodeTreeByParentId(id).then((res) => {
        this.regionList = res.data;
      });
    },
    //获取车辆类别(车主类别)
    getCarCategory() {
      getDictionary('car_category_v2').then((res) => {
        this.carCategoryList = [{
          dictValue: '副车',
          dictKey: '0',
        }, {
          dictValue: '主车',
          dictKey: "1",
        }]
      });
    },
    //车辆类型
    getBigOrSmallCar() {
      getDictionary('car_type_v2').then((res) => {
        this.bigOrSmallCarList = res.data;
      });
    },

    getCarRuleListHandler() {
      getCarRuleList({spaceId: this.value.spaceId, packageType: this.value.carManageType}).then((res) => {
        this.ruleList = res.data;
        this.carRuleDisabled = false;
      })
    },
    //获取优惠规则
    getDiscountList() {
      if (this.value.carManageType != 1) {
        return;
      }
      getCarRuleDiscountList({
        spaceId: this.value.spaceId,
        carFeeRuleId: this.value.feeRuleId,
      }).then((res) => {
        this.discountRuleList = res.data;
      });
    },
    getCarMonthStatus() {
      getDictionary('car_month_status').then((res) => {
        this.statusList = res.data;
      });
    },
    getCarManageTypeList() {
      getDictionary('car_manage_type').then((res) => {
        this.carManageTypeList = res.data;
      });
    },
    approveClick() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          this.value.isNormalUpdate = 1;
          approve(this.value).then((res) => {
            this.$message.success('修改成功');
            this.$emit('success');
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancelRecord() {
      console.log('触发关闭');
      this.$confirm('是否关闭继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$emit('cancel');
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消关闭',
          });
        });
    },
  },
};
</script>
<style scoped>
::v-deep .el-col-8 {
  height: 54px;
}
</style>
